(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[486],{

/***/ "DBub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dollar", function() { return Dollar; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Dollar = function Dollar(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 36.95 53.38"
  }, props, {
    ref: xRef
  }), __jsx("g", null, __jsx("path", {
    d: "M17 53.38v-6.14c-6.58-.31-13.09-2.54-17-6.14l5.83-5.27a17.3 17.3 0 0 0 11.16 5V28.64l-2.79-.43C8.06 27.34 1.74 23.5 1.74 16.43 1.74 8.8 7.75 4.71 17 4.28V0h6v4.4a26.76 26.76 0 0 1 12.77 4.47l-5.64 5.08A19.33 19.33 0 0 0 23 11v11.44l2.36.31C32.73 23.81 37 28.08 37 34.59c0 6.33-5.26 11.23-14 12.41v6.39zm0-31.8V10.73c-4.22.43-6.45 2.48-6.45 5.21 0 3.1 2 5 6.26 5.58zm6 7.87v11c3.47-.93 5.15-3 5.15-5.89 0-2.56-1.43-4.56-5.15-5.11z"
  })));
};

/***/ })

}]);